/* istanbul ignore file */

import { theme } from '@noths/polaris-client-ribbons-base';
import { hideScrollbar } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing } = theme;

const BORDER_RADIUS = 10;
export const MAX_WIDTH = 240;

export const stickyContainer = css`
  position: sticky;
  top: 0;
  z-index: 1;
  background: var(--neutral-white-base);
  padding-bottom: ${spacing.md}px;
`;

export const carouselWrapper = css`
  position: relative;
  width: 100%;
  max-width: ${MAX_WIDTH}px;
  margin: 0 auto;
`;

export const carousel = css`
  position: relative;
  display: flex;
  overflow-x: auto;
  scroll-behavior: auto;
  scroll-snap-type: x mandatory;
  border-radius: ${BORDER_RADIUS}px;

  ${hideScrollbar}
`;

export const slide = css`
  scroll-snap-align: center;
  scroll-snap-stop: always;
  position: relative;
  min-width: 100%;
  height: 0;
  padding-bottom: 100%;
`;

export const image = css`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;
